import React from 'react'
import styles from './Localization.styles'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import LanguageIcon from '@material-ui/icons/Language'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { useAnchorEl } from '@voicekey/libraries/useAnchorEl/useAnchorEl'

const useStyles = makeStyles(styles, { name: 'Localization' })

function Localization ({ onChangeLocale, languages, locale, className }) {
  const classes = useStyles()

  const [anchorEl, handleMenuClick, handleMenuClose] = useAnchorEl()

  const changeLanguage = language => () => {
    onChangeLocale(language)
    handleMenuClose()
  }

  return (
    <>
      <Button
        aria-controls='select-language'
        aria-haspopup='true'
        onClick={handleMenuClick}
        className={className}
        variant='text'
      >
        <LanguageIcon className={classes.icon} />
        {locale}
      </Button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {languages.map(language => (
          <MenuItem
            key={language}
            value={language}
            onClick={changeLanguage(language)}
          >
            {language}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

Localization.propTypes = {
  className: PropTypes.string,
  onChangeLocale: PropTypes.func.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  locale: PropTypes.string.isRequired
}

export default Localization
